<nav>
  <a routerLink="./" routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">Company Details</a>
  &nbsp;&nbsp;&nbsp;
  <a routerLink="./machine-details" routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">Machine Details</a>
  &nbsp;&nbsp;&nbsp;
</nav>
<p>account-details works!</p>
